export default {
  home: {
    minute: 'minuto',
    price_info: 'Gratuito nos primeiros {mianfei} minutos. Uma cobrança diária máxima de {currencyName}{fengding}. O depósito será deduzido automaticamente quando o aluguel atingir {currencyName}{yajin}',
    feature_1: 'Adaptado a todos os tipos de telefones celulares',
    feature_2: 'Pode ser retornado para qualquer outro site',
    feature_3: 'Especialmente projetado - carregamento sem fio (somente para módulos suportados)',
    tips_1: 'Seu depósito de {currencyName}{yajin} será reembolsado após você devolver o banco de energia.',
    tips_2: 'Depósito de recarga {currencyName}{yajin} pode ser alugado, usado pode ser reembolsado',
    tips_3: 'O saldo atual é {currencyName}{myyue}, que pode ser alugado diretamente',
    submit: 'Recarregar',
    borrow: 'Pegar emprestado',
    msg_fail_title: 'Erro',
    msg_fail_content: 'Falha no aluguel, tente novamente',
    msg_rentcount: 'Atualmente você tem {zujieNum} pedidos que não estão fechados',
    goborrow: 'Vá carregar!!!',
    nearby: 'Ver pontos de venda próximos',
    preauth: 'Pré-autorização'
  },
  login: {
    code_title: 'Verificação por SMS',
    phone_number: 'Número de telefone',
    verification_code: 'Por favor, digite o código de verificação SMS',
    captcha_code: 'Código',
    send_code: 'Enviar código',
    login: 'Entrar',
    agree: 'Ao clicar em Login, você concorda com',
    readme: 'Acordo do usuário',
    msg_fail_login: 'Falha no login',
    msg_success_login: 'Sucesso no Login',
    msg_fail_user: 'Erro ao obter informações do usuário. Você quer tentar novamente?',
    sign_in_with: 'Entrar com',
    no_sms: 'Não recebi mensagem de texto',
    retry: 'Reenviar'
  },

  confirm: {
    title: 'Confirmação de Pagamento',
    pay_label: 'Valor',
    auth_label: 'Pré-autorização',
    price_tips: 'Seu saldo pode ser retirado se solicitado. Pode levar de 1 a 5 dias úteis para aparecer em sua conta de pagamento.',
    auth_tips: 'Um valor de pré-autorização de {0}{1} é obrigatório. O valor do aluguel real ocorrido será deduzido quando o powerbank for devolvido.',
    pay_type: 'Por favor, selecione o método de pagamento de sua preferência',
    submit: 'Confirmar pagamento',
    msg_loading: 'Carregando...',
    msg_fail_title: 'Aviso',
    msg_fail_payment: 'Falha ao iniciar o pagamento do depósito',
    msg_fail_order: 'Falha ao criar pedido de locação',
    msg_fail_support: 'O sistema não é suportado',
    msg_fail_confirm: 'Confirmar',
    msg_fail_retry: 'Tentar Novamente',
    msg_fail_cancel: 'Cancelar'
  },

  mine: {
    title: 'Perfil do usuário',
    wallet: 'Minha Carteira',
    balance: 'Meu Saldo',
    deposit: 'Depósito',
    wallet_in: 'Carregar',
    wallet_out: 'Retirar',
    wallet_log: 'Registro da Carteira',
    order: 'Pedido',
    coupon: 'Cupom',
    login_tips: 'Por favor, faça login',
    msg_fail_title: 'Erro',
    msg_fail_update: 'Falha na modificação, tente novamente',
    msg_loading: 'Carregando...',
    msg_fail_user: 'Erro ao obter informações do usuário. Você quer tentar novamente?',
    help: 'ajuda',
    setting: 'Configuração',
    logout: 'Sair',
    buy: 'Comprar equipamento'
  },

  msg: {
    loading: 'Carregando...',
    title: 'Dica',
    success: 'Operação bem-sucedida',
    error: 'Erro desconhecido, tente novamente mais tarde.',
    confirm: 'Confirmar',
    retry: 'Repetir',
    cancel: 'Cancelar',
    title_fail: 'Aviso',
    vieworder: 'Visualizar pedido',
    success_payment: 'Pagamento concluído',
    success_buy: 'Compra concluída',
    fail_payment: 'Falha no pagamento',
    keyword: 'palavra-chave'
  },
  result: {
    title: 'Confirmação de resultado',
    price_plan: 'Padrão de cobrança',
    msg_success: 'Alugado com sucesso',
    msg_tips_loading: 'Bateria portátil irá aparecer, por favor aguarde pacientemente...',
    msg_result_loading: 'O resultado do pagamento está sendo confirmado...',
    msg_fail_confirm: 'Confirmar',
    btn_usage: 'Nota de uso',
    btn_return: 'Nota de devolução',
    deposit: 'Depósito',
    msg_fail_content: 'A solicitação falhou, por favor tente novamente',
    price_label: 'por hora',
    price_info: 'Grátis para os primeiros {mianfei} minutos，Uma cobrança diária máxima de {currency}{fengding}，O depósito será deduzido automaticamente quando o aluguel atingir {currency}{yajin}',
    tips_1: 'Por favor, colete o PowerBank <span class="number">Não.{number}</span> conforme a imagem mostrada',
    tips_2: 'Arrume os cabos e insira o PowerBank na parte inferior com a <span class="highlight">[seta para baixo]</span> ao retornar',
    msg_note_usage: 'O PowerBank está equipado com 3 tipos de cabos e troca sem fio, use conforme necessário.',
    msg_note_return: 'Por favor arrume estes cabos e insira o power bank na cabine com a [seta para baixo] ao retornar.',
    return_info: 'Ao retornar, ajuste bem os cabos e insira o lado com lascas de metal em um espaço vazio até atingir o fundo e estabilizar.'
  },

  result_msg: {
    loading: 'Carregando...',
    refresh: 'Atualizar'
  },
  order: {
    title: 'Pedido de Arrendamento',
    in_use: 'Em uso',
    ended: 'Terminou',
    msg_error: 'Solicitação falhou'
  },
  order_item: {
    order_number: 'Não.',
    venue_rented: 'Local alugado',
    time_rented: 'Tempo alugado',
    venue_returned: 'Local retornado',
    time_returned: 'Hora retornada',
    charge_standard: 'Carga padrão',
    charge_standard_info: '{pJifei} {pCurrency} por hora (primeiros {pMian} minutos grátis)',
    rent_occurred: 'Aluguel ocorrido',
    returned: 'Retornou',
    unreturned: 'Não devolvido',
    type_0: 'Não Completo',
    type_1: 'Alugar',
    type_2: 'Cancelado',
    type_3: 'Devolvido',
    type_4: 'Ocorreu uma falha',
    type_5: 'Horas extras',
    min: 'Minuto',
    payment: 'Pagamento'
  },

  setting: {
    title: 'Configuração',
    lang: 'Idioma'
  },
  help: {
    title: 'FAQ'
  },
  wallet_in: {
    title: 'Recarga de Saldo',
    price_label: 'Valor da recarga',
    price_placeholder: 'Por favor, insira o valor da recarga',
    balance: 'Saldo atual',
    price_auto: 'Escolha o valor do pagamento',
    price_tips: 'Seu saldo pode ser retirado se solicitado. Pode levar de 1 a 5 dias úteis para aparecer em sua conta de pagamento.',
    submit: 'Enviar',
    loading: 'Carregando...',
    paying: 'Ir para a página de pagamento...',
    msg_title: 'Dicas',
    msg_fail_order: 'Falha ao criar pedido de recarga',
    msg_fail_payment: 'Falha ao iniciar o pagamento da recarga',
    msg_fail_retry: 'Tentar Novamente'
  },
  wallet_out: {
    title: 'Retirada',
    price_label: 'Valor da retirada',
    price_placeholder: 'Por favor, insira o valor da retirada',
    balance: 'Saldo atual',
    balance_all: 'Retirar tudo',
    deposit: 'Depósito',
    deposit_tips: 'Existe uma ordem de arrendamento. O depósito de {pcurrencyName}{pyajin} não é reembolsável',
    submit: 'Enviar',
    apply: 'Aplicar',
    confirm: 'Confirmar',
    loading: 'Carregando...',
    msg_fail_price: 'O valor da retirada está incorreto',
    msg_fail_balance: 'O valor do saque não pode ser maior que o saldo atual',
    msg_fail_submit: 'Por favor, preencha as informações completas',
    msg_title: 'Erro',
    msg_success_content: 'Reembolso aplicado com sucesso',
    confirmtitle: 'Dicas',
    confirmcontent: 'A carteira atual não suporta retirada de dinheiro. Anote suas informações de contato e reembolse manualmente',
    payee_name: 'Nome do beneficiário',
    payee_bankcard: 'Número do cartão bancário',
    payee_phone: 'Telefone',
    cancelText: 'cancelar',
    confirmText: 'Reaplicar'
  },
  map: {
    title: 'Perto do equipamento',
    result_msg: 'Nenhum equipamento foi encontrado nas proximidades',
    msg_title: 'erro',
    no_support: 'desculpe! Seu navegador não suporta localização',
    my_position: 'minha localização',
    distance: 'distância:',
    shop_time: 'horas',
    free: 'disponível',
    return: 'retornável',
    shop_title: 'Detalhes do comerciante',
    address: 'endereço',
    go_here: 'Vá aqui'
  }
}
